import {Component, ChangeDetectionStrategy, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {Product} from "../../models/product.model";
import {IPageable} from "../../../snatch/models/page.model";

@Component({
    selector: 'leap-included-products',
    templateUrl: './included-products.component.html',
    styleUrls: ['./included-products.component.less', '../../styles/tab-content.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IncludedProductsComponent implements OnInit {
    @Input() products: Product[];
    @Input() pagination: IPageable;
    @Input() totalCount: number;
    @Input() currencySignsMap: Map<string, string>;
    @Output() pageChanged = new EventEmitter<IPageable>();

    constructor() {}

    ngOnInit() {}

    changePage(page: number): void {
        window.scrollTo({ top: 350, left: 0, behavior: "smooth" });
        this.pageChanged.emit({ page, limit: this.pagination.limit });
    }
}
